import angular from 'angular';
import { HistoricoApuracaoController } from './historico-apuracao.controller';

export class HistoricoApuracaoComponent implements angular.IComponentOptions {
    static selector = 'historicoApuracaoComponent';
    static controller = HistoricoApuracaoController;
    static template = require('!!html-loader!./historico-apuracao.html');
    static bindings = {
        opened: '<',
        apuracao: '<',
        refreshKey: '<',
        onClose: '&?',
    };
}
